module.exports = __webpack_public_path__ + "img/services-case1.9f6f8c61.png";